import { Column } from '@tanstack/react-table';
import { convertCamelCaseToSpace } from '../../../utils/textUtil';

export const getNodeText = (node: any): string | number => {
  if (['string', 'number'].includes(typeof node)) return node;
  if (Array.isArray(node)) return node.map(getNodeText).join('');
  if (typeof node === 'object' && node) return getNodeText(node.props.children);
  return '';
};

export const getHeader = (column: Column<object, unknown>): string | number =>
  getNodeText(column.columnDef.header) || convertCamelCaseToSpace(column.id);
